import React from 'react';

const ThankYou = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-[#060d18] text-white px-4">
      <div className="max-w-xl text-center space-y-6">
        <h1 className="text-4xl font-bold text-[#00c8ff]">Thank You!</h1>
        <p className="text-lg text-gray-300">
          Your message has been successfully sent. I’ll get back to you as soon as possible.
        </p>
        <a
          href="/"
          className="inline-block mt-6 bg-blue-500 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-600 transition-all"
        >
          Back to Home
        </a>
      </div>
    </section>
  );
};

export default ThankYou;
